module.exports = __webpack_public_path__ + "static/media/office-new-york@2x.53ad9057.png";